import GeneralEditPage from './general-edit-page';

export default GeneralEditPage;